import React from 'react';

interface TimeInput12hProps {
  value: string; // "HH:mm" 24h format
  onChange: (value: string) => void; // emits "HH:mm" 24h format
  style?: React.CSSProperties;
}

const TimeInput12h: React.FC<TimeInput12hProps> = ({ value, onChange, style }) => {
  const [h24, m] = (value || '09:00').split(':').map(Number);
  const period = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 || 12;
  const minute = isNaN(m) ? 0 : m;

  const emit = (hour12: number, min: number, ampm: string) => {
    let h = hour12 % 12;
    if (ampm === 'PM') h += 12;
    onChange(`${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`);
  };

  const baseStyle: React.CSSProperties = {
    padding: '6px 8px',
    borderRadius: 6,
    border: '1px solid var(--gray-6)',
    fontSize: 14,
    cursor: 'pointer',
    ...style,
  };

  return (
    <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
      <select
        value={h12}
        onChange={(e) => emit(parseInt(e.target.value), minute, period)}
        style={{ ...baseStyle, minWidth: 52 }}
      >
        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
          <option key={h} value={h}>{h}</option>
        ))}
      </select>
      <span style={{ fontSize: 14, fontWeight: 500 }}>:</span>
      <select
        value={minute}
        onChange={(e) => emit(h12, parseInt(e.target.value), period)}
        style={{ ...baseStyle, minWidth: 52 }}
      >
        {Array.from({ length: 60 }, (_, i) => i).map((min) => (
          <option key={min} value={min}>{String(min).padStart(2, '0')}</option>
        ))}
      </select>
      <select
        value={period}
        onChange={(e) => emit(h12, minute, e.target.value)}
        style={{ ...baseStyle, minWidth: 56 }}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </span>
  );
};

export default TimeInput12h;
